<template>
    <div class="users-list">
        <div class="form is-horizontal">
            <div class="form__group" v-if="showFilters['search']">
                <label class="form__label" for="search" autocomplete="off">{{ __('Search') }}</label>
                <input class="form__control" id="search"
                       v-model="search"
                       v-on:change="getUsers(true)"
            />
            </div>
        </div>

        <router-link class="btn has-margin-b30 is-pulled-left is-primary"
                     v-bind:to="{ name: 'users.add' }"
        >
            <span class="jam jam-plus"></span> {{ __('Add admin user') }}
        </router-link>

        <table class="table is-clearfix">
            <thead>
                <tr>
                    <th>
                        <input type="checkbox"
                               v-bind:checked="selectedItems.length == paging.to - paging.from + 1"
                               v-on:click="selectAllItems"
                        />
                    </th>
                    <th>
                        <a class="sort"
                           v-bind:class="{ 'asc' : sort == 'name_desc', 'desc' : sort == 'name_asc' }"
                           v-on:click="sortBy(sort !== 'name_asc' ? 'name_asc' : 'name_desc')"
                                >
                            {{ __('Name') }}
                        </a>
                    </th>
                    <th>
                        <a class="sort"
                           v-bind:class="{ 'asc' : sort == 'email_desc', 'desc' : sort == 'email_asc' }"
                           v-on:click="sortBy(sort !== 'email_asc' ? 'email_asc' : 'email_desc')"
                                >
                            {{ __('Email') }}
                        </a>
                    </th>
                    <th>
                        <a class="sort"
                           v-bind:class="{ 'asc' : sort == 'role_desc', 'desc' : sort == 'role_asc' }"
                           v-on:click="sortBy(sort !== 'role_asc' ? 'role_asc' : 'role_desc')"
                                >
                            {{ __('Role') }}
                        </a>
                    </th>
                    <th>
                        <a class="sort"
                           v-bind:class="{ 'asc' : sort == 'created_at_desc', 'desc' : sort == 'created_at_asc' }"
                           v-on:click="sortBy(sort !== 'created_at_asc' ? 'created_at_asc' : 'created_at_desc')"
                        >
                            {{ __('Registered at') }}
                        </a>
                    </th>
                    <th>
                        <a class="sort"
                           v-bind:class="{ 'asc' : sort == 'last_login_desc', 'desc' : sort == 'last_login_asc' }"
                           v-on:click="sortBy(sort !== 'last_login_asc' ? 'last_login_asc' : 'last_login_desc')"
                        >
                            {{ __('Last login') }}
                        </a>
                    </th>
                    <th>{{ __('Actions') }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="u in users">
                    <td>
                        <input type="checkbox"
                               v-bind:checked="selectedItems.indexOf(u.id) !== -1"
                               v-on:click="selectItem(u.id)"
                        />
                    </td>
                    <td>{{ u.name }}</td>
                    <td>{{ u.email }}</td>
                    <td>{{ u.role.name }}</td>
                    <td>{{ u.created_at }}</td>
                    <td>{{ u.last_login }}</td>
                    <td>
                        <router-link
                                v-bind:to="{
                                    name: 'users.edit',
                                    params: { user: u.id }
                                }"
                        >
                            Edit
                        </router-link>
                        <span v-if="u.is_admin">/</span>
                        <a v-on:click="openDeleteConfirmModal('delete-user-' + u.id)">
                            Delete
                        </a>
                        <confirm-modal
                                v-bind:id="'delete-user-' + u.id"
                                v-bind:text="__('Are you sure you wish to delete this user?')"
                        ></confirm-modal>
                    </td>
                </tr>
            </tbody>
        </table>

        <div class="users-list__bulk-actions" v-if="selectedItems.length > 0">
            <a class="btn is-pulled-left"
               v-on:click="openDeleteConfirmModal('delete-selected-users')"
                    >
                {{ __('Delete selected') }}
            </a>
            <confirm-modal
                    v-bind:id="'delete-selected-users'"
                    v-bind:text="__('Are you sure you wish to delete all selected users?')"
            ></confirm-modal>
        </div>

        <p v-if="!users">{{ __('Loading users&hellip;') }}</p>
        <p v-if="users && users.length == 0">{{ __('You have no users.') }}</p>

        <paging v-bind:paging="paging" v-if="showPaging"></paging>
    </div>
</template>

<script>
    import { eventBus } from '../eventBus.js';

    import confirmModal from '../elements/ConfirmModal.vue';
    import paging from '../elements/Paging.vue';

    export default {
        components: {
            confirmModal,
            paging
        },
        created: function () {
            // attach event listeners
            eventBus.$on('confirm', this.handleDelete);
        },
        data: function () {
            return {
                paging: {
                    current: 1,
                    from: 1,
                    lastPage: 1,
                    perPage: this.showPaging ? 50 : 0,
                    to: 1,
                    total: 0
                },
                search: null,
                selectedItems: [],
                sort: 'name_asc',
                users: []
            }
        },
        methods: {
            getUsers: function (resetPaging = false) {
                this.users = [];
                if (resetPaging) {
                    this.paging.current = 1;
                }

                let filters = {};

                if (this.search) {
                    filters.search = this.search;
                }

                let sortBy = 'name';
                let sortOrder = 'asc';

                switch (this.sort) {
                    case 'name_asc':
                        sortBy = 'name';
                        sortOrder = 'asc';

                        break;
                    case 'name_desc':
                        sortBy = 'name';
                        sortOrder = 'desc';

                        break;
                    case 'email_asc':
                        sortBy = 'email';
                        sortOrder = 'asc';

                        break;
                    case 'email_desc':
                        sortBy = 'email';
                        sortOrder = 'desc';

                        break;
                    case 'role_asc':
                        sortBy = 'role';
                        sortOrder = 'asc';

                        break;
                    case 'role_desc':
                        sortBy = 'role';
                        sortOrder = 'desc';

                        break;
                    case 'created_at_asc':
                        sortBy = 'created_at';
                        sortOrder = 'asc';

                        break;
                    case 'created_at_desc':
                        sortBy = 'created_at';
                        sortOrder = 'desc';

                        break;
                    case 'last_login_asc':
                        sortBy = 'last_login';
                        sortOrder = 'asc';

                        break;
                    case 'last_login_desc':
                        sortBy = 'last_login';
                        sortOrder = 'desc';

                        break;
                    default:
                        sortBy = this.sort;
                        sortOrder = 'asc';
                }

                eventBus.$emit('show-loader');

                this.$http.get(this.apiUrl + '/users', {
                    params : {
                        filters: filters,
                        page: this.paging.current,
                        perPage: this.paging.perPage,
                        sortBy: sortBy,
                        sortOrder: sortOrder,
                        userRole: this.user.role_id
                    }
                }).then(function (response) {
                    this.paging.from = response.body.original.from;
                    this.paging.lastPage = response.body.original.last_page;
                    this.paging.to = response.body.original.to;
                    this.paging.total = response.body.original.total;
                    this.users = response.body.original.data;

                    eventBus.$emit('hide-loader');
                }.bind(this), function (response) {
                    eventBus.$emit(
                            'show-alert',
                            'error',
                            this.__('There was an error retrieving data from the server.')
                    );

                    eventBus.$emit('hide-loader');
                });
            },
            handleDelete: function (id) {
                let users = this.users;
                let deleteCount = 0;

                this.users.forEach(function (u) {
                    if (
                        id == 'delete-user-' + u.id
                        || (
                            id == 'delete-selected-users'
                            && this.selectedItems.indexOf(u.id) !== -1
                        )
                    ) {
                        eventBus.$emit('show-loader');

                        this.$http.delete(this.apiUrl + '/users/' + u.id).then(function (response) {
                            this.paging.to--;
                            this.paging.total--;
                            deleteCount++;

                            if (id == 'delete-selected-users') {
                                if (deleteCount == this.selectedItems.length) {
                                    window.location.reload();
                                }
                            } else {
                                this.users = users.filter(function (usr) {
                                    return usr.id != u.id
                                });
                            }

                            eventBus.$emit('hide-loader');
                        }.bind(this), function (response) {
                            eventBus.$emit(
                                    'show-alert',
                                    'error',
                                    this.__('There were some errors sending data to server.')
                            );

                            eventBus.$emit('hide-loader');
                        });

                    }
                }.bind(this));
            },
            init: function () {
                this.getUsers(true);
            },
            openDeleteConfirmModal: function (id) {
                eventBus.$emit('open-modal', id);
            },
            selectAllItems: function () {
                if (this.selectedItems.length == this.paging.to - this.paging.from + 1) {
                    this.selectedItems = [];
                } else {
                    this.categories.forEach(function (u) {
                        this.selectedItems.push(u.id);
                    }.bind(this));
                }
            },
            selectItem: function (id) {
                if (this.selectedItems.indexOf(id) !== -1) {
                    this.selectedItems.splice(this.selectedItems.indexOf(id), 1);
                } else {
                    this.selectedItems.push(id);
                }
            },
            sortBy: function (sort) {
                this.sort = sort;

                this.getUsers(true);
            },
            updatePaging: function (newPage, perPage) {
                if (newPage || perPage != this.paging.perPage) {
                    if (newPage) {
                        this.paging.current = newPage;
                    }
                    this.paging.perPage = perPage;

                    this.getUsers();
                }
            }
        },
        mounted: function () {
            this.init();
        },
        props: {
            showFilters: {
                default: null,
                type: Object
            },
            showPaging: {
                default: false,
                type: Boolean
            },
            showSort: {
                default: false,
                type: Boolean
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/UsersList.vue